/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import FormikInput from 'src/components/formik/FormikInput';
import { TargetYupSchema } from 'src/containers/target-container/TargetPropTypes';
import { useHistory } from 'react-router-dom';
import RoutingUtil from 'src/utils/RoutingUtil';
import { isProduction } from 'src/config/index';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import { isValidNumber } from 'src/utils/CommonUtils';
import { targetEditAction, targetResetAction, targetSearchAction, targetUpsertAction } from './actions/TargetActions';
import SlabForm from './components/SlabForm';
import { headerShowAction } from '../header-container/actions/HeaderActions';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import { CAR_LOAN_TYPE_LIST, USED_CAR_LOAN_TYPE_LIST } from '../product-container/ProductConstants';
import FormikSelect from 'src/components/formik/FormikSelect';
import CompanyDropDown from 'src/business-components/CompanyDropDown';
import UserDropDown from 'src/business-components/UserDropDown';
import MultiDropdown from 'src/business-components/MultiDropdown';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
        onSlabItemRemove,
    } = props;

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Team Target Assignment</h5>
                <Form autoComplete="disabled">
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label>Target Name</label>
                            <FormikInput
                                name="targetName"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>From Date</label>
                            <FormikDateTimePicker
                                name="FromDate"
                                className="form-control"
                                disableClock
                                format="dd-MM-yyyy"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>To Date</label>
                            <FormikDateTimePicker
                                name="ToDate"
                                className="form-control"
                                disableClock
                                format="dd-MM-yyyy"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Loan Type</label>
                            <FormikSelect
                                items={CAR_LOAN_TYPE_LIST}
                                name="loanType"
                                className="form-control"
                            />
                        </div>
                        {values.loanType === "USED" &&
                            <div className="form-group col-md-4" >
                                <label>Used Car Loan</label>
                                <FormikSelect
                                    items={USED_CAR_LOAN_TYPE_LIST}
                                    name="usedCarType"
                                    className="form-control"
                                />
                            </div>
                        }
                        <div className="form-group col-md-4">
                            <label>Company</label>
                            <CompanyDropDown
                                name="companyId"
                                value={values.companyId}
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Agent</label>
                            <MultiDropdown name="agentIds" value={values.agentIds} />
                        </div>
                    </div>

                    <SlabForm
                        slab={values.slab}
                        onRemove={onSlabItemRemove}
                    />

                    <div className="text-center py-4 mt-3">
                        <FormikCreateSearchClear
                            isSubmitting={isSubmitting}
                            isUpdate={Boolean(values._id)}
                            onSearch={onSearch}
                            onClear={onClear}
                            resetForm={resetForm}
                            values={values}
                            submitScope="master.target_manager.manage.submit"
                            searchScope="master.target_manager.manage.search"
                        />
                    </div>
                </Form>
{/* 
                <div className="form-group">
                    <RemarkComponent
                        title="Target Remarks"
                        refId={values._id}
                        source="target"
                    />
                </div> */}
            </div>
        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        slab: PropTypes.array,
        agentId: PropTypes.any,
    }).isRequired,
    onSlabItemRemove: PropTypes.func.isRequired,
};

let setSubmitting = () => { };

const TargetForm = () => {
    const history = useHistory();

    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.TargetReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
            || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        const {
            FromDate,
            ToDate,
          } = values;
    
        // Check if CaseFromDate and CaseToDate are present
      if (!FromDate || !ToDate) {
        dispatch(
          headerShowAction({
            data: "FromDate and ToDate are required filters.",
          })
        );
        return;
      }

        if (formikUtils) {
            ({ setSubmitting } = formikUtils);
        }
     
        if (isValidNumber(values?.tempSlab?.target)) {
            if (!isValidNumber(values.tempSlab.reward)) {
                dispatch(headerShowAction({
                    data: 'Target has value but reward does not has value.',
                }));
                setSubmitting(false);
                return;
            }

            if (!values.slab) {
                // eslint-disable-next-line no-param-reassign
                values.slab = [];
            }
            values.slab.push(values.tempSlab);
        }

        // eslint-disable-next-line no-param-reassign
        values.slab = values.slab.sort((a, b) => a.target - b.target);

        includeStamp(values);
        dispatch(targetUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback(({
        targetName,
        commissionType,
        companyId,
    }) => {
        history.push(RoutingUtil.teamTargetSearch({
            targetName,
            commissionType,
            companyId,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(targetResetAction());
    }, [
        dispatch,
    ]);

    const onSlabItemRemove = useCallback((item) => {
        currentRecord.slab = currentRecord.slab.filter((slab) => slab._id !== item._id);
        includeStamp(currentRecord);
        dispatch(targetUpsertAction(currentRecord));
    }, [
        dispatch,
        currentRecord,
    ]);

    return (
        <div>
            <Formik
                onSubmit={onSubmit}
                onClear={onClear}
                enableReinitialize
                initialValues={currentRecord}
                validationSchema={TargetYupSchema}
                onSearch={onSearch}
            >
                {(formikProps) => (
                    <Render
                        onClear={onClear}
                        onSearch={onSearch}
                        onSlabItemRemove={onSlabItemRemove}
                        {...formikProps}
                    />
                )}
            </Formik>
        </div>
    );
};

export default TargetForm;
